import { Component, OnInit } from '@angular/core';
import { FunctionsService } from "../../services/functions.service";
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from '@angular/router';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { SettingsService } from 'src/app/services/settings.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css'],
  providers: [NgxSpinnerService]
})

export class SettingsComponent implements OnInit {

    constructor(
        public functionsService: FunctionsService,
        private router: Router,
        public settingsService: SettingsService,
        private translate: TranslateService
    ) { 
        if(this.router.url==='/'){
            this.router.navigateByUrl('main/activeAlerts');
        }
        this.functionsService.setTitle('setting.settings');
    }
    //selectedAction: string = "";
    lang = "EN";
    language = localStorage.getItem('language')?localStorage.getItem('language'):'en';
    agentDispatch = JSON.parse(localStorage.getItem('agentDispatch'));

    async ngOnInit(){
        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.lang = event["lang"];
        });
        if((['Admin','Owner']).includes(await this.functionsService.getRole())){
            if(this.router.url=="/main/settings"){
                this.settingsService.selectedAction = "setting.email_notifications";
                this.router.navigateByUrl('main/settings/email-notifications');
            }else{
                var path = this.router.url.split("/");
                this.settingsService.selectedAction = "breadcrumb."+path[3];
                return;
            } 
        }
        else{
            this.settingsService.selectedAction = "setting.group_management";
            this.router.navigateByUrl('main/settings/group-management');
        }
    }

    changeAction(action: string) {
        this.settingsService.selectedAction = action;
    }
}
